var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.5C3.75 11.325 3.075 12 2.25 12C1.425 12 0.75 11.325 0.75 10.5C0.75 9.675 1.425 9 2.25 9C3.075 9 3.75 9.675 3.75 10.5ZM2.25 4.5C1.425 4.5 0.75 5.175 0.75 6C0.75 6.825 1.425 7.5 2.25 7.5C3.075 7.5 3.75 6.825 3.75 6C3.75 5.175 3.075 4.5 2.25 4.5ZM2.25 0C1.425 0 0.75 0.675 0.75 1.5C0.75 2.325 1.425 3 2.25 3C3.075 3 3.75 2.325 3.75 1.5C3.75 0.675 3.075 0 2.25 0ZM6.75 3C7.575 3 8.25 2.325 8.25 1.5C8.25 0.675 7.575 0 6.75 0C5.925 0 5.25 0.675 5.25 1.5C5.25 2.325 5.925 3 6.75 3ZM6.75 4.5C5.925 4.5 5.25 5.175 5.25 6C5.25 6.825 5.925 7.5 6.75 7.5C7.575 7.5 8.25 6.825 8.25 6C8.25 5.175 7.575 4.5 6.75 4.5ZM6.75 9C5.925 9 5.25 9.675 5.25 10.5C5.25 11.325 5.925 12 6.75 12C7.575 12 8.25 11.325 8.25 10.5C8.25 9.675 7.575 9 6.75 9Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/DragIndicator.fe1f986d.svg";
export { ForwardRef as ReactComponent };